/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Download_Started_DescriptionInputs */

const en_file_download_started_description = /** @type {(inputs: File_Download_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Follow its progress in your browser's downloads.`)
};

const nl_file_download_started_description = /** @type {(inputs: File_Download_Started_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volg de voortgang in de downloads van uw browser.`)
};

/**
* | output |
* | --- |
* | "Follow its progress in your browser's downloads." |
*
* @param {File_Download_Started_DescriptionInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const file_download_started_description = /** @type {((inputs?: File_Download_Started_DescriptionInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Download_Started_DescriptionInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_file_download_started_description(inputs)
	return en_file_download_started_description(inputs)
});